import { EmployeeUserPayload, SetEmployee } from './typings'

export const setEmployeeActionCreator = (payload: EmployeeUserPayload): SetEmployee => ({
  type: 'referrals/setEmployee',
  payload,
})
